import type {TriggerIntegrationSpec, TriggerIntegrationStruct} from '@cohort/shared/apps/trigger';
import {z} from 'zod';

export const FacebookLikePageTriggerConfigSchema = z.object({
  pageId: z.string().min(1, 'errorRequired'),
  pageName: z.string().min(1, 'errorRequired'),
});
export type FacebookLikePageTriggerConfig = z.infer<typeof FacebookLikePageTriggerConfigSchema>;

export const FacebookLikePageVerificationAttemptDataSchema = z.object({
  userId: z.string(),
  username: z.string(),
});
export type FacebookLikePageVerificationAttemptData = z.infer<
  typeof FacebookLikePageVerificationAttemptDataSchema
>;

export type FacebookLikePageTriggerStruct = TriggerIntegrationStruct<
  'facebook.like-page',
  FacebookLikePageTriggerConfig,
  FacebookLikePageVerificationAttemptData
>;
export const FacebookLikePageTriggerSpec: TriggerIntegrationSpec<FacebookLikePageTriggerStruct> = {
  id: 'facebook.like-page' as const,
  configurableMaxAttempts: false,
  configSchema: FacebookLikePageTriggerConfigSchema,
  verificationAttemptDataSchema: FacebookLikePageVerificationAttemptDataSchema,
  verificationAttemptInputSchema: z.object({}),
  requiresMerchantConnection: true,
};
